import { createContext } from "react";

export const ContentGroupModalContext = createContext();
